<template>
    <nav class="navbar navbar-expand-lg navbar-light py-4 bg-transparent">
        <div class="container py-2 trans-nav-container" :class="transparent ? '' : 'bg-white shadow-sm'">
            <a class="navbar-brand fw-bold fs-4 text-brown ps-3" href="/">
                <img v-if="logo" :src="logo" alt="Logo" height="40">
                <span v-else>Fekra</span>
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                <ul class="navbar-nav gap-4 py-3 py-lg-0">
                    <li class="nav-item"><a class="nav-link" :class="{ 'active rounded-pill px-3': isActive('/') }" href="/">Home</a></li>
                    <li class="nav-item"><a class="nav-link" :class="{ 'active rounded-pill px-3': isActive('/products') }" href="/products">Products</a></li>
                    <li class="nav-item"><a class="nav-link" href="#">About Us</a></li>
                    <li class="nav-item"><a class="nav-link" href="#">Blogs</a></li>
                    <li class="nav-item"><a class="nav-link" href="#">Contact Us</a></li>
                </ul>
            </div>
            <div class="d-flex align-items-center gap-3 pe-3">
                <div class="position-relative">
                    <form @submit.prevent="submitSearch" class="d-flex align-items-center">
                        <input v-if="showSearch" 
                               ref="searchInput"
                               type="text" 
                               class="form-control form-control-sm rounded-pill border-0 shadow-sm me-2" 
                               placeholder="Search..." 
                               v-model="searchQuery"
                               style="width: 200px; transition: all 0.3s ease;">
                        <a href="#" class="text-dark" @click.prevent="toggleSearch">
                            <i class="bi" :class="showSearch ? 'bi-x-lg' : 'bi-search fs-5'"></i>
                        </a>
                    </form>
                </div>
                <a href="/wishlist" class="text-dark position-relative">
                    <i class="bi bi-heart fs-5"></i>
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {{ wishlistCount }}
                    </span>
                </a>
                <a href="/cart" class="text-dark position-relative">
                    <i class="bi bi-bag fs-5"></i>
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {{ cartCount }}
                    </span>
                </a>
                <div class="dropdown" v-if="currentUser">
                    <a href="#" class="text-dark" id="authDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-person fs-5"></i>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end border-0 shadow-sm rounded-4 mt-2" aria-labelledby="authDropdown">
                        <li><a class="dropdown-item" href="#" @click.prevent="logout">Logout</a></li>
                    </ul>
                </div>
                <a v-else href="/customer/login" class="text-dark"><i class="bi bi-person fs-5"></i></a>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        props: {
            transparent: {
                type: Boolean,
                default: false
            },
            logo: {
                type: String,
                default: null
            },
            authUser: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                cartCount: 0,
                showSearch: false,
                searchQuery: '',
                wishlistCount: 0
            }
        },
        mounted() {
            this.fetchCartCount();
            this.fetchWishlistCount();
            window.Bus.$on('cart-updated', (count) => {
                this.cartCount = count !== undefined ? count : this.cartCount + 1; // Increment if no count provided, else set
                // Better to refetch or use provided total quantity
                 if (count === undefined || typeof count !== 'number') {
                     this.fetchCartCount();
                 } else {
                     this.cartCount = count;
                 }
            });
            window.Bus.$on('wishlist-updated', () => {
                this.fetchWishlistCount();
            });
        },
        computed: {
            currentUser() {
                return this.authUser || this.$root.authUser;
            }
        },
        methods: {
            toggleSearch() {
                this.showSearch = !this.showSearch;
                if (this.showSearch) {
                    this.$nextTick(() => {
                        this.$refs.searchInput.focus();
                    });
                }
            },
            submitSearch() {
                if (this.searchQuery.trim()) {
                    window.location.href = `/products?name=${encodeURIComponent(this.searchQuery)}`;
                }
            },
            isActive(route) {
                if (route === '/') {
                    return window.location.pathname === '/' || window.location.pathname === '';
                }
                return window.location.pathname.startsWith(route);
            },
            async logout() {
                try {
                    await axios.post('/customer/logout');
                    window.location.href = '/customer/login';
                } catch (error) {
                    console.error('Logout failed:', error);
                }
            },
            fetchCartCount() {
                if (this.authUser) {
                    axios.get('/api/frontend/cart')
                        .then(response => {
                            if (response.data.data && response.data.data.length > 0) {
                                // Usually api returns { data: [ { cart_items: ... } ] } or similar if collection
                                // or if we changed controller to return single Resource it would be { data: { cart_items: ... } }
                                // My controller returns Collection if carts exist, or empty array.
                                // If collection: data[0].cart_items.length or sum of quantities
                                const carts = response.data.data;
                                if (Array.isArray(carts) && carts.length > 0) {
                                     // Sum items in first active cart
                                     const items = carts[0].cart_items;
                                     this.cartCount = items.length; // Or sum quantity if preferred
                                }
                            }
                        })
                        .catch(error => {
                            // console.error('Error fetching cart count', error);
                        });
                }
            },
            fetchWishlistCount() {
                if (this.authUser) {
                    axios.get('/api/frontend/wishlist')
                        .then(response => {
                            const data = response.data.data;
                            if (Array.isArray(data)) {
                                this.wishlistCount = data.length;
                            }
                        })
                        .catch(error => {
                            console.error('Error fetching wishlist count:', error);
                        });
                }
            }
        }
    }
</script>

<style scoped>
.trans-nav-container {
    border-radius: 1rem; /* Mobile friendly radius */
    transition: all 0.3s ease;
}

@media (min-width: 992px) {
    .trans-nav-container {
        border-radius: 50rem !important; /* Pill shape on desktop */
    }
}
</style>
